/**
 * @file AgentCalls.jsx
 * @description AgentCalls component for displaying and managing agent calls.
 * @component AgentCalls
 * @exports AgentCalls - Main component for displaying and managing agent calls.
 */

import React, { useState, useEffect } from "react";
import LinearProgress from '@mui/material/LinearProgress';
import {
	Box,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
} from "@mui/material";
import { SIZES } from "../../../common/constants/commonConstants.js";
import { CALLS_TABLE_COLUMNS } from "../../../common/constants/agentModule/statusConstants.js";
import { getAgentCalls } from "../../../services/agentModule/agentInfoServices.js";

const AgentCalls = () => {
	const [calls, setCalls] = useState([]);
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		fetchCalls();
	}, []);

	const fetchCalls = async () => {
		setIsLoading(true);
		try {
			const agentguid = localStorage.getItem("userguid");
			const data = await getAgentCalls({ agentguid });
			setCalls(data || []);
		} catch (error) {
			console.error("Error fetching calls:", error);
		} finally {
			setIsLoading(false);
		}
	};

	const formatDate = (isoDate) => {
		const date = new Date(isoDate);
		return date.toLocaleString();
	};

	return (
		<>
			{isLoading ? (
				<>
					<Box sx={{ width: '100%' }}>
						<LinearProgress />
					</Box>
				</>
			) : (
				<>
					<TableContainer>
						<Table size={SIZES.SMALL}>
							<TableHead>
								<TableRow>
									{CALLS_TABLE_COLUMNS.map((column) => (
										<TableCell
											key={column.id}
											sx={{
												width:
													column.id === CALLS_TABLE_COLUMNS.FIRSTNAME ? 150 :
													column.id === CALLS_TABLE_COLUMNS.LASTNAME ? 150 :
													column.id === CALLS_TABLE_COLUMNS.PHONENUMBER ? 100 :
													column.id === CALLS_TABLE_COLUMNS.DATE ? 100 : 200,
											}}
										>
											{column.label}
										</TableCell>
									))}
								</TableRow>
							</TableHead>
							<TableBody>
								{calls.length === 0 ? (
									<TableRow>
										<TableCell colSpan={4} align="center">
											No Calls Found
										</TableCell>
									</TableRow>
								) : (
									calls.map((calls, index) => (
										<TableRow key={index}>
											<TableCell>{calls.lastname}</TableCell>
											<TableCell>{calls.firstname}</TableCell>
											<TableCell>{calls.customeruniqueid}</TableCell>
											<TableCell>{formatDate(calls.createdat)}</TableCell>
										</TableRow>
									))
								)}
							</TableBody>
						</Table>
					</TableContainer>
				</>
			)}
		</>
	);
};

export default AgentCalls;